document.addEventListener("DOMContentLoaded", function() {

  function setMaxHeight() {
    const subheaders = document.querySelectorAll('.multiTextCard__body-subhead');
    let maxHeight = 0;

    subheaders.forEach((subheader) => {
      const height = subheader.clientHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    subheaders.forEach((subheader) => {
      subheader.style.minHeight = `${maxHeight}px`;
    });
  }

  if (window.innerWidth >= 1024) {
    setMaxHeight();
  }

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024) {
      setMaxHeight();
    }
  });

});
